import 'css-chunksrc/client/common/zoneCreationForm/styles.scss';export default {
  "zoneCreationForm": "_zoneCreationForm_3nvrz_1",
  "group": "_group_3nvrz_5",
  "row": "_row_3nvrz_9",
  "name": "_name_3nvrz_17",
  "title": "_title_3nvrz_21",
  "input": "_input_3nvrz_27",
  "textArea": "_textArea_3nvrz_34",
  "buttonBox": "_buttonBox_3nvrz_39",
  "button": "_button_3nvrz_39"
};